import React, { Suspense, useEffect, useState, lazy } from "react";
import GenericTabs from "../../genericComponents/GenericTabs";
import { useSearchParams } from "react-router-dom";

// Lazy load the tab components
const MeetingPrep = lazy(() => import("./tabComps/MeetingPrep"));

function MeetingPrepComp({ accountContactList }) {
  const [tabsToRender, setTabsToRender] = useState([]);
  const [, setSearchParams] = useSearchParams();
        useEffect(() => {
          setSearchParams({
            tab: "meeting_prep",
            subTab: "meeting_prep",
          });
        }, []);
      

  useEffect(() => {
    const tabData = [
      {
        tabId:"meeting_prep",
        label: "Meeting Prep",
        comp: <MeetingPrep />,
      },
      /*{
        label: "Reach Out",
        comp: <ReachOut />,
      },
      {
        label: "Nurture",
        comp: <Nurture />,
      },
      */
    ];

    setTabsToRender(tabData);
  }, []);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <GenericTabs tabs={tabsToRender} />
    </Suspense>
  );
}

export default MeetingPrepComp;
